// ⭐📣 RATE & SHARE — the post-redemption moment: rate the deal, fling a branded win card.
import { useState } from "react";
import axios from "axios";
import { Share2 } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const drawWinCard = (redeem) => new Promise((resolve) => {
  const c = document.createElement("canvas");
  c.width = 1080; c.height = 1080;
  const x = c.getContext("2d");
  const g = x.createLinearGradient(0, 0, 1080, 1080);
  g.addColorStop(0, "#0f172a"); g.addColorStop(0.55, "#1e1b4b"); g.addColorStop(1, "#0f172a");
  x.fillStyle = g; x.fillRect(0, 0, 1080, 1080);
  x.strokeStyle = "#f59e0b"; x.lineWidth = 14; x.strokeRect(34, 34, 1012, 1012);
  x.textAlign = "center";
  x.fillStyle = "#f59e0b";
  x.font = "900 64px Arial";
  x.fillText("🎯 DEAL SCORED!", 540, 190);
  x.fillStyle = "#34d399";
  x.font = "900 150px Arial";
  x.fillText((redeem.discount || "DEAL").slice(0, 12), 540, 420);
  x.fillStyle = "#ffffff";
  x.font = "bold 58px Arial";
  const title = (redeem.title || "").slice(0, 30);
  x.fillText(title, 540, 540);
  x.fillStyle = "#94a3b8";
  x.font = "bold 46px Arial";
  x.fillText(`at ${(redeem.business_name || "a POG spot").slice(0, 28)}`, 540, 630);
  x.fillStyle = "#38bdf8";
  x.font = "900 72px Arial";
  x.fillText("AIR.POG", 540, 850);
  x.fillStyle = "#64748b";
  x.font = "bold 40px Arial";
  x.fillText("Live local deals, on a map — free", 540, 920);
  x.fillText("airpog.com", 540, 985);
  c.toBlob((b) => resolve(b), "image/png");
});

export const RedeemRateShare = ({ redeem }) => {
  const [stars, setStars] = useState(0);
  const [rated, setRated] = useState(false);
  const [sharing, setSharing] = useState(false);

  const rate = async (n) => {
    if (rated) return;
    setStars(n);
    setRated(true);
    try {
      const r = await axios.post(`${API}/deal-reviews`, { token: redeem.token, stars: n }, { withCredentials: true });
      if (r.data.awarded > 0) toast.success(`⭐ Thanks for rating — +${r.data.awarded} POG BUCKS! 🪙`);
      else toast.success("⭐ Rating locked in — thanks, POG'R!");
    } catch (e) { /* rating is best-effort */ }
  };

  const share = async () => {
    setSharing(true);
    const text = `🎯 Just scored ${redeem.discount} — ${redeem.title} at ${redeem.business_name} on AIR.POG! Live local deals on one map: https://airpog.com`;
    try {
      const blob = await drawWinCard(redeem);
      const file = new File([blob], "airpog-win.png", { type: "image/png" });
      if (navigator.canShare?.({ files: [file] })) {
        await navigator.share({ files: [file], title: "AIR.POG deal scored!", text });
        setSharing(false);
        return;
      }
      await navigator.share({ title: "AIR.POG deal scored!", text, url: "https://airpog.com" });
    } catch (e) {
      if (e?.name !== "AbortError") {
        try { await navigator.clipboard.writeText(text); toast.success("Win copied — paste it anywhere! 🔗"); }
        catch (e2) { toast.error("Couldn't open share — select & copy: " + text.slice(0, 60) + "…"); }
      }
    }
    setSharing(false);
  };

  return (
    <div data-testid="redeem-rate-share" className="mt-5 rounded-2xl bg-slate-800/60 border border-slate-700 p-4">
      <p className="text-[11px] font-black tracking-[0.25em] uppercase text-slate-400">How was this deal?</p>
      <div className="flex items-center justify-center gap-2 mt-2">
        {[1, 2, 3, 4, 5].map((n) => (
          <button key={n} data-testid={`rate-star-${n}`} onClick={() => rate(n)}
            className={`text-3xl leading-none transition-transform active:scale-90 ${n <= stars ? "" : "grayscale opacity-60"}`}>
            ⭐
          </button>
        ))}
      </div>
      {rated && <p data-testid="rate-thanks" className="text-[11px] font-bold text-emerald-300 mt-1.5">Locked in — thanks, POG'R! 🎯</p>}
      <button data-testid="share-win-btn" onClick={share} disabled={sharing}
        className="mt-3 w-full h-11 rounded-full bg-gradient-to-r from-amber-400 to-orange-500 text-slate-900 font-heading font-black text-sm flex items-center justify-center gap-2 active:scale-95 transition-transform disabled:opacity-60">
        <Share2 className="w-4 h-4" /> {sharing ? "FORGING CARD…" : "SHARE THE WIN 📣"}
      </button>
    </div>
  );
};
